import _ from 'lodash'
import { getIntermediateTableColumnName } from 'scoreboard/datasets/dataset-utils'

/**
 * Analogous to {@link com.spider.cms.datasets.equations.field.CleanFieldEquationFormatter}
 * Normalizes equations so they appear in a standard format.
 */

/**
 * #32857 Formats a dataset or column/field for a field equation. This is static
 * so it can be used separately
 *
 * @param reference the dataset or column/field to format
 * @param reference {string}
 * @returns {string}
 */
function formatReference(reference) {
	return '[' + reference + ']'
}

/**
 * Gets the column name in the intermediate table from an equation string.
 * This is separate from {@link #formatReference} because it's more domain
 * specific to datasets/equations.
 * @param column {string}
 * @returns {string}
 */
function getEquationForIntermediateTableColumn(column) {
	column = getIntermediateTableColumnName(column)
	return formatReference(column)
}

/**
 * Takes an equation and formats its column references for how they appear
 * in the intermediate table.
 * @param equation {string}
 * @returns {string}
 */
function formatEquationForIntermediateTableColumn(equation) {
	if (_.isNil(equation) || _.isEmpty(equation)) return

	const column = getReference(equation)
	return getEquationForIntermediateTableColumn(column)
}

/**
 * Performs the inverse of the above {@link #formatReference}
 * Note: this does not work for equation strings that are more than one field.
 * @param equation {string} an equation with a single reference
 * @returns {string|undefined}
 */
function getReference(equation) {
	if (_.isNil(equation) || _.isEmpty(equation)) return

	return equation.replace('[', '').replace(']', '')
}

/**
 * Performs the inverse of {@link #formatEquationForIntermediateTableColumn}. This is separate from
 * {@link #getReference} because it's more domain specific to datasets/equations.
 * @param equation {string} an equation with a single reference
 * @returns {string|undefined}
 */
function getIntermediateTableColumnFromBasicEquation(equation) {
	if (_.isNil(equation) || _.isEmpty(equation)) return

	const column = getReference(equation)
	return getIntermediateTableColumnName(column)
}

export {
	getReference,
	formatReference,
	getIntermediateTableColumnFromBasicEquation,
	formatEquationForIntermediateTableColumn,
	getEquationForIntermediateTableColumn
}